var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDictionaryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Preview",
    clipPath: "url(#clip0_805_679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.36512 10.883L14.6398 11.5251C15.1468 11.5602 15.5864 11.1776 15.6215 10.6706C15.6566 10.1635 15.274 9.724 14.7669 9.6889L5.49225 9.04674C4.98521 9.01164 4.54568 9.39424 4.51057 9.90129C4.47546 10.4083 4.85807 10.8479 5.36512 10.883Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.3581 12.8112L5.26569 12.3202C4.75864 12.2851 4.31911 12.6677 4.28401 13.1747C4.2489 13.6818 4.63151 14.1213 5.13855 14.1564L12.2309 14.6475C12.738 14.6826 13.1775 14.3 13.2126 13.7929C13.2477 13.2859 12.8651 12.8463 12.3581 12.8112Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1315 16.0847L5.03913 15.5936C4.53208 15.5585 4.09255 15.9411 4.05745 16.4482C4.02234 16.9552 4.40495 17.3947 4.91199 17.4298L12.0044 17.9209C12.5114 17.956 12.951 17.5734 12.9861 17.0664C13.0212 16.5593 12.6386 16.1198 12.1315 16.0847Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.905 19.3581L4.81256 18.8671C4.30552 18.8319 3.86599 19.2146 3.83088 19.7216C3.79578 20.2286 4.17838 20.6682 4.68543 20.7033L11.7778 21.1943C12.2849 21.2295 12.7244 20.8468 12.7595 20.3398C12.7946 19.8328 12.412 19.3932 11.905 19.3581Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.4171 20.7473L28.1695 25.0579C28.5032 25.4412 28.463 26.0225 28.0795 26.3562C28.0795 26.3562 28.0795 26.3562 28.0795 26.3562M24.4171 20.7473L26.8566 26.2007C27.0053 26.3715 27.2092 26.4659 27.4186 26.4804C27.628 26.4949 27.8431 26.4296 28.0139 26.2808L28.0795 26.3562M24.4171 20.7473C26.2275 18.5843 26.2511 15.3578 24.3415 13.1641C23.8619 12.6131 23.2948 12.1651 22.6675 11.8332L22.9406 7.88889C22.9575 7.64541 22.8769 7.40521 22.7166 7.2211C22.7166 7.2211 22.7166 7.22109 22.7166 7.22109L17.6389 1.3877C17.4787 1.2036 17.2518 1.09066 17.0083 1.0738L5.00558 0.24276C3.29594 0.124389 1.8089 1.41884 1.69053 3.12849L0.172024 25.0604C0.053653 26.77 1.34811 28.257 3.05775 28.3754L18.3337 29.4331C20.0433 29.5514 21.5304 28.257 21.6487 26.5473L21.9294 22.494C22.3123 22.3548 22.6808 22.1751 23.0294 21.9564M24.4171 20.7473L23.0294 21.9564M28.0795 26.3562C27.8879 26.5231 27.6465 26.5965 27.4117 26.5802C27.177 26.564 26.948 26.458 26.7812 26.2663L23.0294 21.9564M28.0795 26.3562L23.0294 21.9564M22.5623 20.0181C22.0688 20.4478 21.4911 20.743 20.8729 20.8913C20.8525 20.8954 20.8325 20.9002 20.8128 20.9055C20.4392 20.989 20.0514 21.0191 19.6586 20.9919C18.5921 20.9181 17.6187 20.4336 16.9168 19.6273C16.2149 18.8209 15.8692 17.79 15.943 16.7235C16.0168 15.657 16.5013 14.6836 17.3077 13.9817C18.114 13.2798 19.1449 12.9341 20.2114 13.0079C20.6043 13.0351 20.9844 13.1184 21.3429 13.2526C21.3616 13.2606 21.3806 13.268 21.4 13.2748C21.9919 13.5068 22.5236 13.879 22.9533 14.3725C24.4018 16.0368 24.2264 18.5695 22.5623 20.0181ZM17.7092 4.27203L19.8695 6.75374L17.5485 6.59304L17.7092 4.27203ZM19.8125 26.4202C19.7642 27.1172 19.1578 27.6451 18.4608 27.5968L3.18489 26.5392C2.48792 26.4909 1.96 25.8845 2.00825 25.1875L3.52676 3.25562C3.57502 2.55865 4.18148 2.03073 4.87845 2.07899L15.9628 2.84644L15.6487 7.38402C15.6136 7.89106 15.9962 8.33059 16.5032 8.3657L21.0408 8.67987L20.8641 11.2319C20.691 11.2043 20.5157 11.184 20.3385 11.1717C18.7819 11.0639 17.276 11.5689 16.0992 12.5934C14.9223 13.6179 14.2145 15.0398 14.1068 16.5964C13.999 18.153 14.504 19.6589 15.5285 20.8358C16.5529 22.0126 17.9749 22.7204 19.5315 22.8282C19.7086 22.8404 19.885 22.8445 20.0603 22.8409L19.8125 26.4202Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_805_679"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(1.99805 0.134766) rotate(3.96069)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictionaryWhite);
export default __webpack_public_path__ + "static/media/dictionary-white.cb2518f3985f00d5466adcd0d081bd30.svg";
export { ForwardRef as ReactComponent };